import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const CheckoutReturnPage = lazy(() =>
  import('./routes/CheckoutReturnPage').then((m) => ({ default: m.CheckoutReturnPage })),
);
const CheckoutCancelledPage = lazy(() =>
  import('./routes/CheckoutCancelledPage').then((m) => ({ default: m.CheckoutCancelledPage })),
);

/**
 * Where Stripe Checkout sends a customer back to, after paying and after leaving.
 *
 * <p>Listed beside the team and support screens, outside the product guard: a customer arriving from
 * Stripe has just bought something, and the guard that decides whether they may see a product's
 * screens must not stand between them and the page that confirms it. Both pages need a session, which
 * the shell supplies; they name no product.
 */
export const moduleBillingRoutes: RouteObject[] = [
  { path: ROUTES.billingModuleSuccess, element: <CheckoutReturnPage /> },
  { path: ROUTES.billingCancel, element: <CheckoutCancelledPage /> },
];
